import { stripActiveHtmlWithReport } from '@messenger/utils'

/**
 * A TinyMCE box's HTML with its active content removed (`stripActiveHtml`:
 * script, meta, base, link and noscript elements, `on*` and `srcdoc`
 * attributes, URLs that run code), for a surface that renders it. HTML with
 * nothing to remove comes back as the same string, so the painted text, its
 * height and the comparison a box makes against its stored value are
 * exactly what they were: parse5 builds the tree the browser builds, so a
 * string it finds nothing active in is one the browser runs nothing from.
 */
export const withoutActiveHtml = (html: string): string => {
  const report = stripActiveHtmlWithReport(html)
  return report.strippedCount > 0 || report.fallback !== null
    ? report.html
    : html
}
